import { C, IMG_COLORS, IMG_LABELS } from "../data/constants";
import { scrollTo } from "../hooks/useScrollFade";

export default function ServiceModal({ service, onClose }) {
  if (!service) return null;
  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 200, background: "rgba(44,40,38,0.82)", display: "flex", alignItems: "center", justifyContent: "center", padding: "16px" }} onClick={onClose}>
      <div style={{ background: C.white, borderRadius: 20, maxWidth: 600, width: "100%", maxHeight: "92vh", overflowY: "auto", position: "relative" }} onClick={e => e.stopPropagation()}>
        <button onClick={onClose} style={{ position: "absolute", top: 12, right: 12, background: C.blush, border: "none", borderRadius: "50%", width: 32, height: 32, fontSize: 16, color: C.white, cursor: "pointer", zIndex: 10 }}>×</button>
        <div style={{ height: "clamp(160px,25vw,220px)", background: IMG_COLORS[service.imgIdx], display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "20px 20px 0 0" }}>
          <div style={{ textAlign: "center", color: "rgba(255,255,255,0.75)" }}>
            <div style={{ fontSize: 40 }}>🌸</div>
            <div style={{ fontSize: 13, marginTop: 6 }}>{IMG_LABELS[service.imgIdx]}</div>
          </div>
        </div>
        <div style={{ padding: "clamp(20px,3vw,28px) clamp(16px,3vw,28px)" }}>
          <p style={{ color: C.blush, fontSize: 11, letterSpacing: 2, textTransform: "uppercase", marginBottom: 7 }}>{service.tag}</p>
          <h3 style={{ fontSize: "clamp(20px,3vw,27px)", fontWeight: 600, color: C.dark, marginBottom: 10 }}>{service.title}</h3>
          <p style={{ color: C.mid, lineHeight: 1.8, marginBottom: 18, fontSize: 14 }}>{service.desc}</p>
          <p style={{ fontSize: "clamp(17px,2.5vw,20px)", fontWeight: 600, color: C.dark, marginBottom: 7 }}>Starting {service.price}</p>
          <p style={{ color: C.slate, fontSize: 13, lineHeight: 1.7, marginBottom: 22 }}>Choose from Bronze, Silver or Gold — or build your own custom setup.</p>
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
            <button onClick={() => { onClose(); scrollTo("packages"); }}
              style={{ flex: 1, minWidth: 120, background: "none", border: `1px solid ${C.blush}`, color: C.blush, padding: "11px", borderRadius: 22, fontSize: 14, cursor: "pointer" }}>
              View Packages
            </button>
            <button onClick={() => { onClose(); scrollTo("contact"); }}
              style={{ flex: 1, minWidth: 120, background: C.blush, color: C.white, border: "none", padding: "11px", borderRadius: 22, fontSize: 14, cursor: "pointer" }}>
              Book Now 
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}